import { NavLink } from 'react-router-dom';
import React from 'react';

const MainNav = () => (
  <div className='navbar-nav mr-auto'>
    <NavLink to='/' exact className='nav-link' activeClassName='router-link-exact-active'>
      Home
    </NavLink>
    {/*<NavLink to='#contact' exact className='nav-link' activeClassName='router-link-exact-active'>
      Contact
    </NavLink>
   <NavLink to='/profile' exact className='nav-link' activeClassName='router-link-exact-active'>
      User Profile
    </NavLink>
     <NavLink to='/external-api' exact className='nav-link' activeClassName='router-link-exact-active'>
      External API
    </NavLink> */}
    <NavLink to={{ pathname: 'https://www.facebook.com/MichelsMfg/' }} target='_blank' exact className='nav-link' activeClassName='router-link-exact-active'>
      <i class='fa fa-facebook' />
    </NavLink>
    <NavLink to={{ pathname: 'https://twitter.com/michelsmfg?lang=en' }} target='_blank' exact className='nav-link' activeClassName='router-link-exact-active'>
      <i class='fa fa-twitter' />
    </NavLink>
  </div>
);

export default MainNav;
